export default "__VITE_ASSET__BoqLYb$B__"